/**
 * Premium surface tokens — glass, gradient shells, and interactive card scaffolds.
 * Uses the LockedIn emerald/dark palette (not mockup-specific colors).
 */
import { semanticColors } from './colors';

const { accent, surface, border, background } = semanticColors;

/** Backdrop blur + glass fill combinations */
export const glassSurfaces = {
  /** Default frosted panel — cards, sections */
  panel: `${surface.glass} ${border.subtle} backdrop-blur-xl`,
  /** Stronger glass for sticky chrome (header, bottom nav) */
  chrome: 'bg-black/60 border-white/[0.08] backdrop-blur-xl',
  /** Elevated glass card with subtle brand rim */
  elevated: `${surface.glass} ${border.subtle} backdrop-blur-xl border-emerald-500/10`,
  /** Inset well for nested content */
  inset: `${surface.inset} ${border.DEFAULT}`,
};

/** Gradient overlays for hero / section backgrounds */
export const gradientSurfaces = {
  /** Subtle top-down fade into app background */
  heroFade: 'bg-gradient-to-b from-emerald-500/[0.06] via-transparent to-transparent',
  /** Bottom scrim for legibility over imagery */
  bottomScrim: 'bg-gradient-to-t from-black/80 via-black/40 to-transparent',
  /** Sport-agnostic section wash */
  sectionWash: 'bg-gradient-to-br from-white/[0.04] via-transparent to-emerald-500/[0.03]',
};

/** Composed interactive card surface — pair with shadows.elevation.interactive */
export const interactiveCard = {
  base: `${glassSurfaces.panel} ${background.app}`,
  hover: 'motion-safe:md:hover:border-emerald-500/20 motion-safe:md:hover:bg-white/[0.07]',
  focusWithin: 'focus-within:border-emerald-500/30 focus-within:ring-1 focus-within:ring-emerald-500/20',
};

/** Wallet / balance hero surface */
export const walletSurface = {
  card: 'bg-gradient-to-br from-purple-500/20 via-gray-900/80 to-black/90 border-purple-500/30',
  chip: 'bg-purple-500/15 border-purple-500/35 backdrop-blur-md',
};

/**
 * @param {'panel'|'chrome'|'elevated'|'inset'} [variant='panel']
 */
export function glassSurfaceClasses(variant = 'panel') {
  return glassSurfaces[variant] || glassSurfaces.panel;
}
